'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();
import { User } from '@qogita/canary-client'
import { usePathname, useSearchParams } from 'next/navigation'
import { Suspense, use, useEffect, useRef } from 'react'

import { clearUser, identifyUser, initializeSegment, trackPageView } from '.'

export function SegmentInitialize({
  writeKey,
  isTrackingEnabled,
  maybeUserPromise,
}: {
  writeKey: string
  isTrackingEnabled: boolean
  maybeUserPromise: Promise<User | null>
}) {
  useInitializeSegment({ writeKey, isTrackingEnabled })

  useTrackPageView({ isTrackingEnabled })

  if (!isTrackingEnabled) return null

  return (
    // Suspending so we don't block the whole app while waiting for the user to be fetched
    <Suspense fallback={null}>
      <IdentifyUser maybeUserPromise={maybeUserPromise} />
    </Suspense>
  )
}

function useInitializeSegment({
  writeKey,
  isTrackingEnabled,
}: {
  writeKey: string
  isTrackingEnabled: boolean
}) {
  const hasSegmentInitialized = useRef(false)

  useEffect(() => {
    if (hasSegmentInitialized.current) return
    if (!isTrackingEnabled) return
    if (!writeKey) return

    initializeSegment({ writeKey })
    // We should only initialize segment once
    hasSegmentInitialized.current = true
  }, [writeKey, isTrackingEnabled])
}

function useTrackPageView({
  isTrackingEnabled,
}: {
  isTrackingEnabled: boolean
}) {
  const pathname = usePathname() ?? ''
  const searchParams = useSearchParams()
  const queryString = String(searchParams)

  useEffect(() => {
    if (!isTrackingEnabled) return

    trackPageView(pathname, queryString)
  }, [pathname, queryString, isTrackingEnabled])
}

function IdentifyUser({
  maybeUserPromise,
}: {
  maybeUserPromise: Promise<User | null>
}) {
  const maybeUser = use(maybeUserPromise)

  useEffect(() => {
    if (!maybeUser) {
      clearUser()
      return
    }

    identifyUser(maybeUser)
  }, [maybeUser])

  return null
}
